import DefaultDatePicker from './DefaultDatePicker';
import $ from '../../vendor/CustomJquery';
import 'air-datepicker';
import { parseDate } from '../Helpers';

export default class DateRangePicker extends DefaultDatePicker {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-date-range-picker');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.instance( $(element) );
    });
  }

  instance(input) {

    let value = input.val(),
        isWithTimepicker = (input.data('isWithTimepicker') === true);

    let datePicker = input.datepicker({
      language:       this.App.Language.getLocale(),
      autoClose:      true,
      position:       this._DEFAULT_POSITION,
      todayButton:    new Date(),
      clearButton:    true,
      onShow:         (instance, animationComplete) => {
        return this.onShow(instance, animationComplete);
      },
      onHide:         (instance) => {
        return this.onHide(instance);
      },
      onSelect:       (formattedDate, date, instance) => {
        return this.onSelect(formattedDate, date, instance)
      },
      range:          true,
      toggleSelected: false,
      multipleDatesSeparator: ' - ',
      timepicker:     isWithTimepicker
    }).data('datepicker');

    if (value.length > 0) {
      value = value.split('-');

      datePicker.selectDate([
        parseDate($.trim(value[0])),
        parseDate($.trim(value[1]))
      ]);
    }

    input.on('keydown', function(event) {
      if (event.which === 13 || event.keyCode === 13) {
        let value = this.value.split('-');
        event.preventDefault();
        $(this).data('datepicker').selectDate(
          parseDate($.trim(value[0])),
          parseDate($.trim(value[1]))
        );
      }
    });

  }

}